import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=4bfbddca&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=4bfbddca&prod&scoped=true&lang=css"
import style1 from "./pagination.vue?vue&type=style&index=1&id=4bfbddca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbddca",
  null
  
)

export default component.exports